<div class="popup-container tlms-popup">
	<header>
		<div class="header" style="display:block">Add Holiday</div>
		<button class="close" style="top:-3px" (click)="close()">
			<mat-icon>close</mat-icon>
		</button>
	</header>
	<ng-container>
		<div style="padding: 16px 24px 16px 24px;">
			<div class="col-12" style="width: 100%;">
				<div class="upload">
					<div class="content-line">
						<label class="catlabel">Description:
							<span style="color:#ff0000">*</span>
						</label>
						<span class="content">
							<input type="text" id="desc" name="desc" required minlength="4" maxlength="100" class="desc"
								[(ngModel)]="description">
						</span>
					</div>
					<div class="content-line">
						<label class="catlabel"> Start Date:
							<span style="color:#ff0000">*</span>
						</label>
						<span class="content">
							<input type="date" id="sdate" name="sdate" required class="sdate" [(ngModel)]="startDate">
						</span>
					</div>
					<div class="content-line">
						<label class="catlabel"> End Date:
							<span style="color:#ff0000">*</span>
						</label>
						<span class="content">
							<input type="date" id="edate" name="edate" required class="edate" [(ngModel)]="endDate"
								[disabled]="enableEndDate" [min]="startDate">
						</span>
					</div>
					<label *ngIf="enableError" class="errormsg"> {{errormsg}} </label>
				</div>
			</div>
		</div>
		<div class="cfooter d-flex justify-content-between align-items-center popup-footer">
			<button (click)="onNoClick()" class="mCancel"> CANCEL
			</button>
			<button class="taskm-submit" style="display: inline" (click)="saveClick()">
				SAVE
			</button>
		</div>
	</ng-container>
</div>